<template>
  <div class="name">
    <template v-if="numberOfParticipants === 1">
        <span
            class="tw-text-black tw-text-base tw-font-semibold"
            :class="[{'tw-font-bold' : bold},sizeClass]"
            v-text="participants[0].firstname + ' ' + participants[0].lastname"
        ></span>
    </template>
    <template v-else-if="numberOfParticipants === 2">
        <span class="tw-text-black tw-text-base"
            :class="{'tw-font-bold' : bold}">{{
            `${participants[0].firstname} en ${participants[1].firstname}`
        }}</span>
    </template>
    <template v-else>
        <span class="tw-text-black tw-text-base"
            :class="{'tw-font-bold' : bold}">{{
            `${participants[0].firstname} en ${numberOfParticipants - 1} andere`
        }}</span>
    </template>
  </div>
</template>

<script>
export default {
	name: 'ThreadName',
	props: ['participants', 'bold', 'size'],
	computed: {
		numberOfParticipants() {
			return this.participants.length;
		},
		sizeClass() {
			return `tw-text-${this.size}`;
		}
	},
};
</script>

<style lang="scss" scoped></style>
